import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin, Sparkles, MapPinned } from 'lucide-react';
import { useSiteContent } from '@/hooks/useSiteContent';

export default function Footer() {
  const { content } = useSiteContent();
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 font-display font-extrabold text-2xl text-white">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl"
              style={{ background: 'linear-gradient(135deg, #10B981 0%, #7C3AED 100%)' }}>
              <Sparkles className="w-5 h-5 text-white" />
            </span>
            Dubinko
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Premium servis dubinskog čišćenja u Nišu. Vraćamo sjaj domovima, kancelarijama i tapaciranom nameštaju.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Usluge</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/usluge#residential" className="hover:text-white">Stanovi i kuće</Link></li>
            <li><Link to="/usluge#commercial" className="hover:text-white">Poslovni prostori</Link></li>
            <li><Link to="/usluge#carpet" className="hover:text-white">Tepisi i tapacirung</Link></li>
            <li><Link to="/podrucja" className="hover:text-white">Područja koja pokrivamo</Link></li>
            <li><Link to="/recenzije" className="hover:text-white">Recenzije</Link></li>
            <li><Link to="/rezervacija" className="hover:text-white">Online rezervacija</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Kompanija</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/o-nama" className="hover:text-white">O nama</Link></li>
            <li><Link to="/kontakt" className="hover:text-white">Kontakt</Link></li>
            <li><Link to="/prijava" className="hover:text-white">Prijava</Link></li>
            <li><Link to="/registracija" className="hover:text-white">Registracija</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-emerald-400" /> {content.phone}</li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-emerald-400" /> {content.email}</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-emerald-400" /> {content.address}</li>
            {content.gbp_url && (
              <li>
                <a href={content.gbp_url} target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-2 mt-1 hover:text-white">
                  <MapPinned className="w-4 h-4 text-emerald-400" /> Google Business Profile
                </a>
              </li>
            )}
            <li>
              <a href={content.instagram} target="_blank" rel="noreferrer"
                 className="inline-flex items-center gap-2 mt-1 hover:text-white">
                <Instagram className="w-4 h-4 text-purple-400" /> @dubinko_nis_018
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="container-x py-6 text-xs text-slate-500 flex flex-col md:flex-row gap-2 items-center justify-between">
          <span>© {new Date().getFullYear()} Dubinko · Niš, Srbija. Sva prava zadržana.</span>
          <span>Premium deep cleaning service</span>
        </div>
      </div>
    </footer>
  );
}
